
import angular from 'angular';

import { ParametersTagGroupAddController } from './parameters.tag-group.add.controller.js';

ParametersTagsGroupsController.$inject = ['MAX_TAG_GROUP_NUMBER', '$interval', 'TopToolbarFactory', '$scope', 'ParametersFactory', '$state', '$stateParams', 'tagsGroups', 'AlertingFactory', '$uibModal', 'loggedUser', 'MediasFactory'];
export function ParametersTagsGroupsController(MAX_TAG_GROUP_NUMBER, $interval, TopToolbarFactory, $scope, ParametersFactory, $state, $stateParams, tagsGroups, AlertingFactory, $uibModal, loggedUser, MediasFactory) {

  init();
  $scope.editTagGroup = editTagGroup;
  $scope.deleteTagGroup = deleteTagGroup;
  $scope.addTagGroup = addTagGroup;

  function addTagGroup() {
    let modalInstance = $uibModal.open({
      animation: true,
      backdrop: 'static',
      template: require('./parameters.tag-group.add.html'),
      controller: ParametersTagGroupAddController,
      resolve: {
        companyHasRoutingTag: function () {
          return $scope.companyHasRoutingTag;
        }
      }
    });
    modalInstance.result.then(function (result) {
      if (result == null) {
        AlertingFactory.error('parameters/tags_groups/add_tag_group/ko');
      } else {
        $scope.companyHasRoutingTag = (result.is_routing || $scope.companyHasRoutingTag) ? true : false;
        $scope.myTagGroups.push(result);
        AlertingFactory.success('parameters/tags_groups/add_tag_group/ok');
      }
    });

  }

  function editTagGroup(tagGroup) {
    $state.go('auth.alcmeon.parameters.tags-groups.details', {
      'tagGroupId': tagGroup.id
    });
  }

  function deleteTagGroup(tagGroup) {
    let modalInstance = $uibModal.open({
      animation: true,
      template: require('../../confirmation/confirmation.modal.html'),
      controller: 'ConfirmationController',
      resolve: {
        text: function () {
          return 'parameters/tags_groups/confirmation/delete_tag_group';
        }
      }
    });
    modalInstance.result.then(function (result) {
      ParametersFactory.deleteTagGroup($stateParams.companyId, tagGroup.id).then(function (result) {
        $scope.myTagGroups = result.data;
        $scope.companyHasRoutingTag = ($scope.myTagGroups.find(tagGroupObj => tagGroupObj.is_routing == 1)) ? true : false;
        AlertingFactory.success('parameters/tags_groups/delete_tag_group/ok');
      }, error => {
        if (error.data && error.data.message === 'parameters/tags_groups/delete_tag_group/unable') {
          AlertingFactory.error('parameters/tags_groups/delete_tag_group/unable');
          $scope.error = error;
        } else {
          AlertingFactory.error('parameters/tags_groups/delete_tag_group/ko');
        }
      });
    });
  }

  function sortTagGroups() {
    $scope.myTagGroups.sort(function (a, b) {
      return a.display_order - b.display_order;
    });
  }

  function exportTags() {
    ParametersFactory.exportTags($stateParams.companyId).then(response => {
      const { content, content_type, content_filename } = response.data;
      MediasFactory.downloadBinaryBase64(content, content_type, content_filename);
    }, AlertingFactory.httpErrorHandler())
  }

  function init() {
    TopToolbarFactory.setTitleTranslation('parameters/tags_groups/tags', $scope);
    TopToolbarFactory.setButton('tags/export/button', exportTags, $scope);
    $scope.lang = (!angular.isUndefined(loggedUser.lang)) ? loggedUser.lang : 'en';
    $scope.myTagGroups = tagsGroups;
    sortTagGroups();
    $scope.companyHasRoutingTag = ($scope.myTagGroups.find(tagGroupObj => tagGroupObj.is_routing == 1)) ? true : false;
    $scope.maxTagGroupNumber = MAX_TAG_GROUP_NUMBER;

    $scope.intervalStop = $interval(function () {
      ParametersFactory.getTagGroups($stateParams.companyId).then(function (response) {
        $scope.myTagGroups = response.data;
        sortTagGroups();
      });
    }, 60000);
    $scope.$on('$destroy', function () {
      // Make sure that the interval is destroyed too
      $interval.cancel($scope.intervalStop);
    });

    var tagGroupOrderHasChanged = false;
    $scope.sortableOptions = {
      change: () => tagGroupOrderHasChanged = true,
      stop: () => {
        if (tagGroupOrderHasChanged) {
          for (var index = 0; index < $scope.myTagGroups.length; index++) {
            let indexPlusOne = index + 1;
            $scope.myTagGroups[index].display_order = indexPlusOne;
            let update = {
              'display_order': indexPlusOne
            };
            ParametersFactory.updateTagGroup($stateParams.companyId, $scope.myTagGroups[index].id, update).then(function (result) {
              if (!angular.isUndefined(result.status) && !angular.isUndefined(result.data.error.reason)) {
                AlertingFactory.error('parameters/tags_groups/update_tag_group/ko');
              } else {
                AlertingFactory.success('parameters/tags_groups/update_tag_group/ok');
              }
            });
          }
          tagGroupOrderHasChanged = false;
        }
      }
    };
  }
}
